import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ErrorModalService } from '../../services/error-modal-service.service';
import { ErrorBody } from '../../models/error.interface';
import { Subscription } from 'rxjs';
import { DialogDefaultsDirective } from '../../directives/dialog-defaults.directive';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, DialogModule, DialogDefaultsDirective],
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnDestroy {
  showDialog: boolean = false;
  errorBody: ErrorBody | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(private errorModalService: ErrorModalService) {
    const modalVisibleSub = this.errorModalService.isModalVisible$.subscribe(
      (isVisible) => {
        this.showDialog = isVisible;
      },
    );
    this.subscriptions.add(modalVisibleSub);

    const errorBodySub = this.errorModalService.errorBody$.subscribe(
      (errorBody) => {
        this.errorBody = errorBody;
      },
    );
    this.subscriptions.add(errorBodySub);
  }

  closeModal = () => {
    this.errorModalService.hide();
    if (this.errorBody?.code === 'PV003') {
      window.location.reload();
    }
  };

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
